import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuditState } from '@store/reducers';

export const selectAuditState = createFeatureSelector<AuditState>('audit');

export const selectAuditLoading = createSelector(
  selectAuditState,
  (state: AuditState) => state.loading
);

export const selectAuditEditMode = createSelector(
  selectAuditState,
  (state: AuditState) => state.editMode
);

export const selectAuditIsEditing = createSelector(
  selectAuditState,
  (state: AuditState) => state.isEditing
);

export const selectAuditId = createSelector(
  selectAuditState,
  (state: AuditState) => state.auditId
);

export const selectAudit = createSelector(
  selectAuditState,
  (state: AuditState) => state.audit
);

export const selectAuditList = createSelector(
  selectAuditState,
  (state: AuditState) => state.auditList
);

export const selectAuditForm = createSelector(
  selectAuditState,
  (state: AuditState) => state.auditForm
);

export const selectAuditFormValid = createSelector(
  selectAuditState,
  (state: AuditState) => state.formValid
);

export const selectAuditInmutable = createSelector(
  selectAuditState,
  (state: AuditState) => state.auditInmutable
);

export const selectAuditError = createSelector(
  selectAuditState,
  (state: AuditState) => state.error
);